/**
 * Conversão da periodicidade textual de um exame (defaultFrequency do catálogo)
 * para o número de meses usado na aplicação do exame.
 *
 * Aceita rótulos nomeados (Anual, Semestral, Bienal, ...) e valores numéricos
 * (ex: "12", "12 meses", "24 Meses").
 */

const NAMED_FREQUENCIES: Array<{ pattern: RegExp; months: number }> = [
  // Ordem importa: "bianual"/"bienal" contém "anual", então vem antes.
  { pattern: /bienal|bianual/, months: 24 },
  { pattern: /trienal/, months: 36 },
  { pattern: /quinquenal/, months: 60 },
  { pattern: /semestral/, months: 6 },
  { pattern: /quadrimestral/, months: 4 },
  { pattern: /trimestral/, months: 3 },
  { pattern: /bimestral/, months: 2 },
  { pattern: /mensal/, months: 1 },
  { pattern: /anual/, months: 12 },
];

const MIN_MONTHS = 1;
const MAX_MONTHS = 120;

/**
 * Converte a periodicidade textual em meses. Retorna `null` quando não é
 * possível interpretar (texto vazio, desconhecido ou fora da faixa 1–120).
 */
export function parseFrequencyToMonths(frequency: string | null | undefined): number | null {
  if (!frequency) return null;

  const normalized = frequency
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, ''); // remove acentos

  if (normalized === '') return null;

  for (const { pattern, months } of NAMED_FREQUENCIES) {
    if (pattern.test(normalized)) return months;
  }

  // Fallback numérico: "12", "12 meses", etc.
  const match = normalized.match(/\d+/);
  if (match) {
    const months = parseInt(match[0], 10);
    if (months >= MIN_MONTHS && months <= MAX_MONTHS) return months;
  }

  return null;
}
